import { AgerasMarketplaceActions } from 'client/actions/actionTypes'
import { Analytics } from 'client/Global/Analytics'
import { AnalyticsType, Category, Events, Placement, Result } from 'client/Global/AnalyticsEvents'
import { ReducerBuilder } from 'client/reducers/ReducerBuilder'

export const initialState = {
  loaded: false,
  token: null as string,
  responseId: null as string,
  verifying: false,
  verificationStatus: 200,
  phone: null as string,
  success: false,
}

export type MarketplaceState = typeof initialState

const saveToken = (state: MarketplaceState) => {
  return {
    ...state,
    loaded: true,
  }
}

const requestVerification = (state: MarketplaceState, payload: any) => {
  return {
    ...state,
    phone: payload.phone,
  }
}

const loadPhone = (state: MarketplaceState, phone: string) => {
  return {
    ...state,
    phone,
  }
}

const saveResponseId = (state: MarketplaceState, responseId: string) => {
  return {
    ...state,
    success: false,
    verificationStatus: 200,
    phone: null,
    responseId,
  }
}

const saveVerification = (state: MarketplaceState, payload) => {
  if (payload instanceof Error) {
    return {
      ...state,
      success: false,
      verificationStatus: 400,
    }
  }

  return {
    ...state,
    success: true,
    verificationStatus: 200,
  }
}

export default new ReducerBuilder(initialState)
  .mapAction(AgerasMarketplaceActions.SAVE_TOKEN, saveToken)
  .mapAction(AgerasMarketplaceActions.LOAD_PHONE, loadPhone)
  .mapAction(AgerasMarketplaceActions.SAVE_RESPONSE_ID, saveResponseId)
  .mapAction(AgerasMarketplaceActions.REQUEST_VERIFICATION, requestVerification)
  .mapAction(AgerasMarketplaceActions.SUBMIT_VERIFICATION, saveVerification)
  .build()
